import { Component, Input, OnInit } from '@angular/core';
import { AttributeModel } from 'src/app/shared/models/attribute.model';

@Component({
    standalone: false,
    selector: 'app-link-attribute-list',
    templateUrl: './link-attribute-list.component.html',
    styleUrls: ['./link-attribute-list.component.scss']
})
export class LinkAttributeListComponent implements OnInit {

    @Input()
    links: AttributeModel[]

    constructor() { }

    ngOnInit(): void { }

    openLink(link: string) {
        window.open(link, '_blank');
    }

}
